import { conf } from '../../configService';

// @see https://schema.org/Organization
export const organizationType = () => ({
  '@type': 'Organization',
  '@id': `https://${conf.canonicalDomain}/`,
  name: conf.siteName,
  url: `https://${conf.canonicalDomain}/`,
  logo: {
    '@type': 'ImageObject',
    url: `https://${conf.canonicalDomain}/images/logo.png`
  }
});
